function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h52v52H0z"
}), React.createElement("rect", {
  width: 38,
  height: 46,
  x: 7,
  y: 3,
  stroke: "#3FC0C4",
  strokeWidth: 2,
  rx: 5
}), React.createElement("rect", {
  width: 19,
  height: 9,
  x: 20,
  y: 11,
  stroke: "#3FC0C4",
  strokeWidth: 2,
  rx: 2
}), React.createElement("path", {
  fill: "#3FC0C4",
  d: "M12.486 3.021h2V50h-2z"
}));

var SvgKnowledgesharing = function SvgKnowledgesharing(props) {
  return React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MiIgaGVpZ2h0PSI1MiIgdmlld0JveD0iMCAwIDUyIDUyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMGg1MnY1MkgweiIvPgogICAgICAgIDxyZWN0IHdpZHRoPSIzOCIgaGVpZ2h0PSI0NiIgeD0iNyIgeT0iMyIgc3Ryb2tlPSIjM0ZDMEM0IiBzdHJva2Utd2lkdGg9IjIiIHJ4PSI1LjIyOCIvPgogICAgICAgIDxyZWN0IHdpZHRoPSIxOC41NDEiIGhlaWdodD0iOS4yMzQiIHg9IjE5Ljk3MyIgeT0iMTEuMTciIHN0cm9rZT0iIzNGQzBDNCIgc3Ryb2tlLXdpZHRoPSIyIiByeD0iMi4wOTEiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjM0ZDMEM0IiBkPSJNMTIuNDg2IDMuMDIxaDJWNTBoLTJ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgKnowledgesharing as ReactComponent };